/*
* Project: LegalPlace assistant
* File: src/redux/reducers/app_state.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import * as validator from 'validator';
import {
  LP_STATE_CHECKOUT,
  LP_STATE_WIZARD,
  LP_STATE_PAYMENT,
  LP_STATE_PRE_WIZARD,
  SET_STATE,
} from '../actions/app_state';
import { store } from '../../globals';
import writeHistory from '../../logic/history';
import lpApp from '../../app/lp_app';
import { HARCODED_CHECKOUT_META_IDS } from '../../constants/hardcoded_checkout';


export function appStateReducer(state = LP_STATE_WIZARD, action) {
  if (action.type === SET_STATE) {
    // Check the change type, and then do something for it, (pass params if it's possible.)
    if ((state === LP_STATE_WIZARD)) {
      document.body.id = 'page-wizard';
      if (action.state === LP_STATE_CHECKOUT) { // mail section
        if (store.getState().account_settings.mail.length > 0
          && validator.isEmail(store.getState().account_settings.mail)
        ) {
          return LP_STATE_PAYMENT;
        }
      }
    }
    const historyMutex = lpApp.mutex.checkMutex('history');
    switch (action.state) {
      case LP_STATE_CHECKOUT:
        if (store.getState().document_state.state === 'continue') {
          if (historyMutex) writeHistory('normal', true, store.getState().contract.currentSection, store.getState().document_state.unique);
          else lpApp.mutex.setMutex('history', true); // v(historyMutex)
        } else if (historyMutex) writeHistory('normal', false, store.getState().contract.currentSection + 1, '');
        else lpApp.mutex.setMutex('history', true);
        if ((HARCODED_CHECKOUT_META_IDS.indexOf(lpApp.contractMetaId) > -1)) {
          document.body.id = 'ce_v3';
        } else {
          document.body.id = 'page-wizard';
        }
        break;
      case LP_STATE_PAYMENT:
        // window.history.pushState({state: store.getState()}, "Paiement", "/paiement");
        if (store.getState().document_state.state === 'continue' && store.getState().contract.comeFrom !== 'creer') {
          if (historyMutex) {
              if(!action.ignoreHistory) {
                writeHistory('payment', true, 0, store.getState().document_state.unique);
              }
          } else {
              lpApp.mutex.setMutex('history', true);
          }
        } else if (historyMutex) {
            if(!action.ignoreHistory) {
              writeHistory('payment', false, 0, store.getState().document_state.unique);
            }
        }
        else {
            lpApp.mutex.setMutex('history', true);
        }

        if ((HARCODED_CHECKOUT_META_IDS.indexOf(lpApp.contractMetaId) > -1)) {
          document.body.id = 'ce_v3';
        } else {
          document.body.id = 'page-checkout';
        }
        break;
      case LP_STATE_WIZARD: {
        document.body.id = 'page-wizard';
        break;
      }
      default:
      case LP_STATE_PRE_WIZARD:

        break;
    }
    return action.state;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/app_state.js